import Vue from 'vue'
import VueRouter from 'vue-router'
import Master from "./pages/Master";
import Map from "./pages/Map";
import Index from "./pages/Index";
import Blog from "./pages/Blog";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import BlogPost from "@/pages/BlogPost.vue";
Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/map',
            component: Map
        }, {
            path: "/map/:hashed_id",
            component: Map
        }, {
            path: "/map/category/:category_id",
            component: Map
        }, {
            path: '/',
            component: Master,
            children: [
                {
                    path: '',
                    component: Index,
                }, {
                    path: '/aboutus',
                    component: AboutUs,
                }, {
                    path: '/contactus',
                    component: ContactUs,
                }, {
                    path: '/blog',
                    component: Blog,
                }, {
                    path: '/blog/:slug',
                    component: BlogPost
                }
            ]
        }
    ]
});

let loader;

router.beforeEach((to, from, next) => {
    loader = Vue.$loading.show({
        loader: "dots",
    });
    next()
});

router.afterEach(() => {
    loader.hide();
});

export default router;